import React, { useState, useEffect, useRef } from "react";
import { useLocation, Link, useHistory } from "react-router-dom";

import "../assets/vendor/bootstrap/css/bootstrap.min.css";
import "../assets/css/venobox.css";
import "../assets/vendor/remixicon/remixicon.css";
import "../assets/css/style.css";
import $ from "jquery";
import NEWGIF from "../assets/img/new-3.gif";
import UrlParamChecker, { UrlParamFaq } from './UrlChecker';

const NavBar = (props) => {




  const location = useLocation();





  const ham = !(UrlParamChecker() && UrlParamFaq)
  // console.log(ham)
  // useEffect(() => {
  //   if (test && ham)
  //     ham.style.display = 'none'
  // }, [ham]
  // )

  useEffect(() => {
    if ($("body").hasClass("mobile-nav-active")) {
      $("body").removeClass("mobile-nav-active");
      $(".mobile-nav-toggle i").toggleClass("ri-menu-line ri-close-line");
      $(".mobile-nav-overly").fadeOut();
      window.location.reload(window.location.pathname);

    }


  }, [location.pathname]);

  useEffect(() => {
    var scrolltoOffset = $("#header").outerHeight() - 21;
    $(document).on(
      "click",
      ".nav-menu a, .mobile-nav a, .scrollto",
      function (e) {
        if (
          window.location.pathname == this.pathname.replace(/^\//, "") &&
          location.hostname == this.hostname
        ) {
          console.log("location3", window.location.pathname, this.pathname);
          var target = $(this.hash);
          if (target.length) {
            e.preventDefault();

            var scrollto = target.offset().top - scrolltoOffset;

            if ($(this).attr("href") == "#header") {
              scrollto = 0;
            }

            $("html, body").animate(
              {
                scrollTop: scrollto,
              },
              1500,
              "easeInOutExpo"
            );

            if ($(this).parents(".nav-menu, .mobile-nav").length) {
              $(".nav-menu .active, .mobile-nav .active").removeClass("active");
              $(this).closest("li").addClass("active");
            }

            if ($("body").hasClass("mobile-nav-active")) {
              $("body").removeClass("mobile-nav-active");
              $(".mobile-nav-toggle i").toggleClass(
                "ri-menu-line ri-close-line"
              );
              $(".mobile-nav-overly").fadeOut();
            }
            return false;
          }
        }
      }
    );

    // Back to top button
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $(".back-to-top").fadeIn("slow");
      } else {
        $(".back-to-top").fadeOut("slow");
      }
    });

    $(".back-to-top").click(function () {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        1500,
        "easeInOutExpo"
      );
      return false;
    });
    $("#rd").click(function () {
      window.location.hash = "#/FaqRbiRetailDirect";
    });

    $("#gs").click(function () {
      window.location.hash = "#/FaqGovernmentActRegulations";
    });

    $("#pi").click(function () {
      window.location.hash = "#/FaqPrimaryIssuances";
    });

    $("#gb").click(function () {
      window.location.hash = "#/FaqGoldBonds";
    });

    $("#fr").click(function () {
      window.location.hash = "#/FaqFrsb";
    });

    $("#sm").click(function () {
      window.location.hash = "#/FaqNdsOmSecondaryMarket";
    });

    // Mobile Navigation
    if (($(".nav-menu").length)) {

      var $mobile_nav = $(".nav-menu").clone().prop({
        class: "mobile-nav d-lg-none",
      });
      $("body").append($mobile_nav);
      if (ham) {
        $("body").prepend(
          '<button type="button" id = "mobileHamburger" class="mobile-nav-toggle d-lg-none"><i class="ri-menu-line"></i></button>'
        );
      }
      $("body").append('<div class="mobile-nav-overly"></div>');

      $(document).on("click", ".mobile-nav-toggle", function (e) {
        $("body").toggleClass("mobile-nav-active");
        $(".mobile-nav-toggle i").toggleClass("ri-menu-line ri-close-line");
        $(".mobile-nav-overly").toggle();
      });

      $(document).on("click", ".mobile-nav .drop-down > a", function (e) {
        e.preventDefault();
        $(this).next().slideToggle(300);
        $(this).parent().toggleClass("active");
      });

      $(document).click(function (e) {
        var container = $(".mobile-nav, .mobile-nav-toggle");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          if ($("body").hasClass("mobile-nav-active")) {
            $("body").removeClass("mobile-nav-active");
            $(".mobile-nav-toggle i").toggleClass("ri-menu-line ri-close-line");
            $(".mobile-nav-overly").fadeOut();
          }
        }
      });
    } else if ($(".mobile-nav, .mobile-nav-toggle").length) {
      $(".mobile-nav, .mobile-nav-toggle").hide();
    }

    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $("#header").addClass("header-scrolled");
      } else {
        $("#header").removeClass("header-scrolled");
      }
    });

    if ($(window).scrollTop() > 100) {
      $("#header").addClass("header-scrolled");
    }

  }, [ham]);

  var flags = document.getElementsByClassName("reg_lang");

  Array.prototype.forEach.call(flags, function (e) {
    e.addEventListener("click", function () {
      var lang = e.getAttribute("data-lang");
      var languageSelect = document.querySelector("select.goog-te-combo");
      if (languageSelect) {
        languageSelect.value = lang;
        languageSelect.dispatchEvent(new Event("change"));
      }
    });
  });
  const history = useHistory()

  const [selectedFaq, setSelectedFaq] = useState(location.pathname + location.search);

  return (
    <div >
      <div style={UrlParamChecker() ? { display: "none", margin: "-60px" } : {}}>
        <header

          id="header"
          // ref={myRef}
          className="fixed-top d-flex align-items-center header-transparent"
        >
          <div className="container d-flex align-items-center">
            <div className="logo mr-auto">
              <Link to="/" className="branding">
                &nbsp;
              </Link>
            </div>

            <nav className="nav-menu d-none d-lg-block">
              <ul>
                <li className={location.pathname == "/" ? "active" : ""}>
                  <Link className="nav-links" to="/">
                    Home
                  </Link>
                </li>

                <li
                  className={
                    location.pathname == "/about_investor" ||
                      location.pathname == "/about_rbi_retail" ||
                      location.pathname == "/about_scheme" ||
                      location.pathname == "/about_auction_calendar" ||
                      location.pathname == "/about_statistics"
                      ? "drop-down active"
                      : "drop-down"
                  }
                >
                  <a href="#">About</a>
                  <ul>
                    <li>
                      <Link className="nav-links" to="/about_scheme">
                        RBI Retail Direct Scheme
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-links" to="/about_rbi_retail">
                        RBI Retail Direct Regulations
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-links" to="/about_investor">
                        Customer Service Timelines
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-links" to="/about_auction_calendar">
                        Auction Calendar
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-links nav-abt-statistic" to="/about_statistics">
                        Statistics
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className={location.pathname == "/News" ? "active" : ""}>
                  <Link className="nav-links" to="/News">
                    News
                  </Link>
                </li>

                <li
                  className={
                    location.pathname == "/FaqGoldBonds" ||
                      location.pathname == "/FaqNdsOmSecondaryMarket" ||
                      location.pathname == "/FaqRbiRetailDirect" ||
                      location.pathname == "/FaqGovernmentActRegulations" ||
                      location.pathname == "/FaqFrsb" ||
                      location.pathname == "/FaqGovernmentSecurities" ||
                      location.pathname == "/FaqPrimaryIssuances"
                      ? "drop-down active"
                      : "drop-down"
                  }
                >


                  <a href="#">FAQs</a>
                  <ul>
                    <li>
                      <Link
                        className="nav-links"
                        to="/FaqGovernmentActRegulations"
                      >
                        Government Securities Act and Regulations
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-links" to="/FaqGovernmentSecurities">
                        Understanding Government Securities
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-links" to="/FaqPrimaryIssuances">
                        Primary Issuances Non Competive Bidding
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-links" to="/FaqGoldBonds">
                        Sovereign Gold Bonds
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-links" to="/FaqFrsb">
                        Floating Rate Savings Bond 2020
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-links" to="/FaqNdsOmSecondaryMarket">
                        NDS OM Secondary Market
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-links" to="/FaqRbiRetailDirect">
                        RBI Retail Direct
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className={location.pathname == "/Tour" ? "active" : ""}>
                  <Link className="nav-links" to="/Tour">
                    <img
                      src={NEWGIF}
                      style={{ position: "absolute", top: "-4px" }}
                    />{" "}
                    Tour
                  </Link>
                </li>

                <li className="drop-down">
                  <a href="" className="loginBt">
                    Login
                  </a>
                  <ul>
                    <li><a href="https://rbiretaildirect.in" target="_blank">RBI Retail Direct Account</a></li>
                    <li><a href="https://retail.ndsom.com" target="_blank">NDS-OM Secondary Market</a></li>
                    <li><a href="https://rbiretaildirect.in/#/rdg-account-registration" target="_blank">Registration</a></li>
                  </ul>
                </li>

                <li className="drop-down language">
                  {/* <a href="">
                  Language
                </a> */}
                  <a className="nav-links" href=""><label className="langBeta">beta</label>Language</a>
                  <ul>
                    <li><a href="/" target="_self" title="English">English (Default)</a></li>
                    <li><a href="/HI" target="_self" title="Hindi">हिन्दी</a></li>
                    <li><a href="/AS" target="_self" title="Assamese">অসমীয়া</a></li>
                    <li><a href="/BN" target="_self" title="Bengali">বাংলা</a></li>
                    <li><a href="/GU" target="_self" title="Gujrati">ગુજરાતી</a></li>
                    <li><a href="/KN" target="_self" title="Kannada">ಕನ್ನಡ</a></li>
                    <li><a href="/ML" target="_self" title="Malayalam">മലയാളം</a></li>
                    <li><a href="/MR" target="_self" title="Marathi">मराठी</a></li>
                    <li><a href="/OR" target="_self" title="Oriya">ଓଡିଆ (ଓଡିଆ)</a></li>
                    <li><a href="/PA" target="_self" title="Punjabi">ਪੰਜਾਬੀ</a></li>
                    <li><a href="/TA" target="_self" title="Tamil">தமிழ்</a></li>
                    <li><a href="/TE" target="_self" title="Telugu">తెలుగు</a></li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </header>

      </div>
      <a href="#" className="back-to-top">
        <i className="ri-arrow-up-s-line"></i>
      </a>

      <div className="container" style={UrlParamChecker() && UrlParamFaq() ? { marginBottom: "-75px" } : { height: "0", display: "none", margin: "-60px" }} >
        <div className="section-title" style={UrlParamChecker() && UrlParamFaq() ? { marginTop: "16px" } : { height: "0", display: "none" }}>
          <h2>FAQs </h2>
        </div>

        <select name="Faq" defaultValue={selectedFaq} className='form-select w-100 custom-select-nav  '
          onChange={e => {

            setSelectedFaq(e.target.value)
            history.push(e.target.value)
          }
          } >
          < option
            className="nav-options "
            value="/FaqGovernmentActRegulations/?app=true"
          >Government Securities Act and Regulations</ option>


          < option className="nav- options" value="/FaqGovernmentSecurities/?app=true">
            Understanding Government Securities
          </ option>


          < option className="nav- options" value="/FaqPrimaryIssuances/?app=true">
            Primary Issuances Non Competive Bidding
          </ option>


          < option className="nav- options" value="/FaqGoldBonds/?app=true">
            Sovereign Gold Bonds
          </ option>


          < option className="nav- options" value="/FaqFrsb/?app=true">
            Floating Rate Savings Bond 2020
          </ option>


          < option className="nav- options" value="/FaqNdsOmSecondaryMarket/?app=true">
            NDS OM Secondary Market
          </ option>


          < option className="nav- options" value="/FaqRbiRetailDirect/?app=true">
            RBI Retail Direct
          </ option>
        </select>

      </div>

    </div>
  );
};

export default NavBar;
